export var ReplyAction;
(function (ReplyAction) {
    ReplyAction["Reply"] = "Reply";
    ReplyAction["ReplyAll"] = "ReplyAll";
})(ReplyAction || (ReplyAction = {}));
//# sourceMappingURL=reply-action.js.map